"use client"

import AddUserModal from "@/components/AddUserModal";
import UsersTable from "@/components/UsersTable";
import { UserSchema } from "@/schemas/user.schema";
import { getAllUsers } from "@/services/users.service";
import { useEffect, useState } from "react";
import { z } from "zod";


export default function Users() {
    const [users, setUsers] = useState<z.infer<typeof UserSchema>[]>([]);

    const loadAllUsers = async () => {
        const users = await getAllUsers();
        setUsers(users);
    }

    useEffect(() => {
        loadAllUsers()
    }, [])

    return (
        <div>
            <AddUserModal onAddSuccess={loadAllUsers} />
            <UsersTable users={users} />
        </div>
    )
}